import React from 'react';

import { Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';

import { USER_DETAILS_TAB_GROUPS, UserDetailsTabKey, UserDetailsTabs } from './userDetailsTabs';

interface Props {
  tabs: UserDetailsTabs;
  currentTab: UserDetailsTabKey;
  onChange: (tab: UserDetailsTabKey) => void;
}

export default function UserDetailsNavigation({ tabs, currentTab, onChange }: Props) {
  return (
    <Box
      component="nav"
      aria-label="User sections"
      sx={{
        position: { md: 'sticky' },
        top: 16,
        alignSelf: 'start',
        maxHeight: { md: 'calc(100vh - 32px)' },
        overflowY: 'auto',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.paper',
        p: 1,
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(3, minmax(0, 1fr))', md: '1fr' },
        gap: 1,
      }}
    >
      {USER_DETAILS_TAB_GROUPS.map((group) => {
        const visibleTabs = group.tabs.filter((tab) => tabs[tab].showTab);
        if (!visibleTabs.length) {
          return null;
        }

        return (
          <Box key={group.label}>
            <Typography variant="overline" component="div" color="primary.main" sx={{ px: 1.5, fontWeight: 700 }}>
              {group.label}
            </Typography>
            <List disablePadding>
              {visibleTabs.map((tab) => (
                <ListItemButton
                  key={tab}
                  component="button"
                  type="button"
                  selected={currentTab === tab}
                  aria-current={currentTab === tab ? 'page' : undefined}
                  onClick={() => onChange(tab)}
                  sx={{
                    width: '100%',
                    borderRadius: 1,
                    px: 1.5,
                    py: 0.5,
                    '&.Mui-selected': { color: 'primary.dark' },
                  }}
                >
                  <ListItemText
                    primary={tabs[tab].label}
                    primaryTypographyProps={{ variant: 'body2', fontWeight: currentTab === tab ? 600 : 400 }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Box>
        );
      })}
    </Box>
  );
}
